<template>
    <div class="occasion-teaser-item" @click="goToOccasion">
        <div class="inner">
            <div class="row">
                <div class="col-md-4 teaser-image">
                    <img :src="image" :alt="item.field_title" width="245" height="175">
                </div>
                <div class="col-md-8">
                    <p class="occasion-title"><a :href="item.field_url">{{ item.field_title }}</a></p>

                    <div class="intro-information">
                        <div class="price info-item">{{ item.field_prijs | toCurrency }}</div>
                        <div class="info-item">Kilometerstand: {{ item.field_kilometerstand }}</div>
                        <div class="info-item">Bouwjaar: {{ item.field_bouwjaar }}</div>
                    </div>

                    <div class="extra-information">
                        <div class="info-item">Brandstof: {{ item.field_brandstof }}</div>
                        <div class="info-item">Transmissie: {{ item.field_transmissie }}</div>
                        <div class="info-item">Carrosserie: {{ item.field_carrosserie }}</div>
                    </div>

                    <template v-if="hasGarage === true">
                        <div class="garage">
                            <div class="inner">
                                <div class="name">
                                    {{ item.field_garage.name }}
                                </div>

                                <div class="tel">
                                    Tel: <a :href="`tel:${phoneNumber.number}`">{{ item.field_garage.tel }}</a>
                                </div>

                                <div class="email">
                                    Email: <a :href="`mailto:${email}`">{{ email }}</a>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';

export default {
    name: "OccasionListItem",

    props: ['item'],

    filters: {
        toCurrency(value) {
            value = parseInt(value);

            if (typeof value !== "number") {
                return value;
            }

            let formatter = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            });

            return formatter.format(value);
        }
    },

    computed: {
        hasGarage() {
            return ! _.isEmpty(this.item.field_garage);
        },

        phoneNumber() {
            if (! this.hasGarage) {
                return;
            }

            return parsePhoneNumber(this.item.field_garage.tel, 'NL');
        },

        image() {
            if (_.isEmpty(this.item.field_afbeelding)) {
                return '/themes/custom/ef2_custom/img/occasion-placeholder.jpg';
            }

            return this.item.field_afbeelding;
        },

        email() {
            if (!_.isNull(this.item.field_garage.salesEmail)) {
                return this.item.field_garage.salesEmail;
            }

            return this.item.field_garage.email;
        }
    },

    methods: {
        goToOccasion() {
            window.location = this.item.field_url;
        }
    }
}
</script>
